import Icon from '../components/Icon.vue'

Icon.register({"xing":{"width":1408,"height":1792,"paths":[{"d":"M597 667q-10 18-257 456-27 46-65 46h-239q-21 0-31-17t0-36l253-448q1 0 0-1l-161-279q-12-22-1-37 9-15 32-15h239q40 0 66 45zM1403 25q11 16 0 37l-528 934v1l336 615q11 20 1 37-10 15-32 15h-239q-42 0-66-45l-339-622q18-32 531-942 25-45 64-45h241q22 0 31 15z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/xing.js
// module id = 2002
// module chunks = 0